/**
 * @generated SignedSource<<5263b90594c7ab6a9243391c5929828b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsHeroStatusContact_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useTradeBenefitsContact_viewer">;
  readonly " $fragmentType": "TradeBenefitsHeroStatusContact_viewer";
};
export type TradeBenefitsHeroStatusContact_viewer$key = {
  readonly " $data"?: TradeBenefitsHeroStatusContact_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsHeroStatusContact_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsHeroStatusContact_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTradeBenefitsContact_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "871cb904399748d76ad56556e5e8d134";

export default node;
